import styled from 'styled-components';

const MainButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #9da1bb;
  background-color: #f7f8f9;
  border: 3px solid #e2e5ef;
  border-radius: 5px;
  width: 135px;
  height: 35px;
  cursor: pointer;
  font-family: 'Karla', sans-serif;
  padding: 5px;

`;

export default MainButton;



// WEBPACK FOOTER //
// ./client/shared/MainButton.js